import { useTranslation } from 'react-i18next';
import { Form } from '@anytag/shared-atoms';
import { MkpFormFields } from '@anytag/shared-organisms';
import { TikTokCampaignDisabledFieldsType, TikTokCampaignFormKeys } from '../types';

interface PackageInformationProps {
  disabledFields: TikTokCampaignDisabledFieldsType;
}
export const PackageInformation = ({ disabledFields }: PackageInformationProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Form.SectionTitle index={1} label={t('Advanced Campaign Package')} />

      <Form.Fields itemsPerRow={2}>
        <MkpFormFields.PreLaunchDateField<TikTokCampaignFormKeys>
          name="preLaunchDate"
          disabled={disabledFields.preLaunchDate}
        />

        <MkpFormFields.CampaignPeriodField<TikTokCampaignFormKeys>
          endDateProps={{ name: 'endDate', disabled: disabledFields.endDate }}
          startDateProps={{ name: 'startDate', disabled: disabledFields.startDate }}
          required
        />

        <MkpFormFields.CampaignCategoryField<TikTokCampaignFormKeys>
          name="campaignCategoryId"
          disabled={disabledFields.campaignCategoryId}
          required
        />
      </Form.Fields>
    </>
  );
};
